import { TranslationKey } from '../functions/i18n';

export const de: Record<TranslationKey, string> = {
  'nav.records': 'Einträge',
  'nav.meds': 'Medikamente',
  'nav.guide': 'Bibliothek',
  'nav.options': 'Erinnerungen',
  'topbar.welcome': 'Willkommen',
  'splash.tagline': 'Master Pet Health. Conquer the Fellowship.',
  'records.tab.todayEntry': 'Täglich',
  'records.tab.allCards': 'Verlauf',
  'records.tab.worksheet': 'Daten',
  'meds.title': 'Medikamente',
  'meds.empty': 'Noch keine Medikamente hinzugefügt',
  'trends.title': 'Trends',
  'trends.noDataTitle': 'Noch keine Daten',
  'trends.noDataBody': 'Erfassen Sie Ihre Vitalwerte im Karten-Tab, um hier Trends zu sehen.',
  'trends.moreDataNeeded': 'Mehr Daten erforderlich',
  'trends.moreDataNeededBody': 'Wir benötigen mindestens 3 Tage mit erfassten Daten, um Trends zu erstellen. Weiter so!',
  'trends.avgWeight': 'Ø Gewicht',
  'trends.avgHeartRate': 'Avg Heart Rate',
  'trends.avgRespRate': 'Ø Atemfrequenz',
  'trends.avgMucousMembrane': 'Ø Schleimhäute',
  'trends.avgWaterIntake': 'Ø Wasseraufnahme',
  'trends.avgTemperature': 'Ø Temperatur',
  'trends.weightTrend': 'Weight Trend',
  'trends.heartRateTrend': 'Heart Rate Trend',
  'trends.respRateTrend': 'Respiratory Rate Trend',
  'trends.mucousMembraneTrend': 'Verteilung der Schleimhäute',
  'trends.fluidIntakeTrend': 'Water Intake Trend',
  'trends.foodIntakeTrend': 'Trend Futteraufnahme',
  'trends.avgFoodIntake': 'Ø Futteraufnahme',
  'trends.day': 'Tag',
  'trends.days': 'Tage',
  'trends.tooltipWeight': 'Gewicht',
  'trends.tooltipFluid': 'Flüssigkeitsaufnahme',
  'trends.tooltipFood': 'Futteraufnahme',
  'trends.tooltipHeartRate': 'Heart Rate',
  'trends.tooltipRespRate': 'Resp. Rate',
  'trends.tooltipMucousMembrane': 'Schleimhäute',
  'trends.fluidBalanceTrend': 'Flüssigkeitsbilanz-Trend',
  'trends.tempTrend': 'Temperatur-Trend',
  'trends.moodTrend': 'Stimmungs-Trend',
  'trends.mucousMembrane.pink': 'Rosa',
  'trends.mucousMembrane.red': 'Rot',
  'trends.mucousMembrane.blue': 'Blau',
  'trends.mucousMembrane.white': 'Weiß',
  'trends.noMucousMembraneData': 'Für diesen Zeitraum wurden noch keine Schleimhaut-Einträge erfasst.',
    'trends.moodLabel.terrible': 'Sehr schlecht',
    'trends.moodLabel.notGreat': 'Nicht gut',
    'trends.moodLabel.okay': 'Okay',
    'trends.moodLabel.good': 'Gut',
    'trends.moodLabel.great': 'Sehr gut',
  'trends.tooltipFluidBalance': 'Flüssigkeitsbilanz (Ein − Aus)',
  'trends.tooltipTemp': 'Temperatur',
  'trends.tooltipMood': 'Stimmung',
  'trends.customise': 'Anpassen',
  'trends.resetLayout': 'Layout zurücksetzen',
  'trends.viewPlans': 'Pläne ansehen',
  'trends.trendsLockedTitle': 'Trends sind eine kostenpflichtige Funktion',
  'trends.trendsLockedBody': 'Abonnieren Sie KodaCare, um Ihr Gewicht, Blutdruck, Flüssigkeitszufuhr und mehr über die Zeit zu verfolgen.',
  'trends.lifetimeLockedTitle': 'Lifetime-Funktion',
  'trends.lifetimeLockedBody': 'Upgraden Sie auf den Lifetime-Plan, um Atemfrequenz-, Schleimhaut- und Temperaturtrends sowie ein vollständig anpassbares Diagrammlayout freizuschalten.',
  'guide.digestLockedTitle': 'Monatlicher Nieren-Digest',
  'guide.digestLockedBody': 'Upgraden Sie auf den Lifetime-Plan, um unseren kuratierten monatlichen Newsletter zu erhalten — die bedeutendsten Neuigkeiten aus Nierentechnologie, Medikamentenforschung und Berichten aus der Transplantationsgemeinschaft.',
  'options.title': 'Benachrichtigungen',
  'options.appPreferences': 'App-Einstellungen',
  'options.language': 'Sprache',
  'options.units': 'Einheiten',
  'options.metric': 'Metrisch',
  'options.imperial': 'Imperial',
  'options.dateFormat': 'Datumsformat',
  'options.timeFormat': 'Zeitformat',
  'options.transplant': 'Transplantation',
  'options.editProfile': 'Profil bearbeiten',
  'options.saveToHomeScreen': 'App installieren',
  'options.logOut': 'Abmelden',
  'options.fullName': 'Vollständiger Name',
  'options.profession': 'Beruf',
  'options.professionPlaceholder': 'z.B. Krankenpfleger, Chirurg',
  'options.emailAddress': 'E-Mail-Adresse',
  'options.emailCannotChange': 'E-Mail kann nicht geändert werden.',
  'options.transplantDate': 'Transplantationsdatum',
  'options.changePassword': 'Passwort ändern',
  'options.deleteAccount': 'Konto löschen',
  'options.cancel': 'Abbrechen',
  'options.saveChanges': 'Änderungen speichern',
  'login.email': 'E-Mail',
  'login.password': 'Passwort',
  'login.forgotPassword': 'Passwort vergessen?',
  'login.signIn': 'Anmelden',
  'login.continueWithGoogle': 'Mit Google fortfahren',
  'login.noAccount': 'Noch kein Konto?',
  'login.register': 'Registrieren',
  'login.or': 'oder',
  'login.rememberMe': '30 Tage angemeldet bleiben',
  'forgot.title': 'Passwort zurücksetzen',
  'forgot.subtitle': 'Geben Sie Ihre E-Mail-Adresse ein, und wir senden Ihnen einen Link zum Zurücksetzen Ihres Passworts.',
  'forgot.checkInboxTitle': 'Posteingang prüfen',
  'forgot.checkInboxBody': 'Wir haben einen Link zum Zurücksetzen des Passworts an {email} gesendet. Folgen Sie dem Link, um ein neues Passwort festzulegen.',
  'forgot.spamHint': 'Nicht erhalten? Prüfen Sie Ihren Spam- oder Junk-Ordner.',
  'forgot.backToSignIn': 'Zurück zur Anmeldung',
  'forgot.sendResetLink': 'Link zum Zurücksetzen senden',
  'forgot.rememberPassword': 'Passwort wieder eingefallen?',
  'forgot.legal': 'Mit der Anmeldung stimmen Sie unseren Nutzungsbedingungen und unserer Datenschutzrichtlinie zu.',
  'forgot.errorNoAccount': 'Kein Konto mit dieser E-Mail-Adresse gefunden.',
  'forgot.errorNetwork': 'Netzwerkfehler. Bitte prüfen Sie Ihre Verbindung und versuchen Sie es erneut.',
  'forgot.errorGeneric': 'E-Mail zum Zurücksetzen konnte nicht gesendet werden. Bitte versuchen Sie es erneut.',
  'verify.title': 'E-Mail verifizieren',
  'verify.subtitle': 'Wir haben einen Bestätigungslink an {email} gesendet. Klicken Sie auf den Link in dieser E-Mail und melden Sie sich danach erneut an.',
  'verify.errorResend': 'Die E-Mail konnte nicht erneut gesendet werden. Bitte versuchen Sie es gleich noch einmal.',
  'verify.resent': 'Bestätigungs-E-Mail erneut gesendet — bitte prüfen Sie Ihren Posteingang.',
  'verify.emailSent': 'E-Mail gesendet ✓',
  'verify.resend': 'Bestätigungs-E-Mail erneut senden',
  'verify.backToSignIn': 'Zurück zur Anmeldung',
  'verify.spamHint': 'Nicht erhalten? Prüfen Sie Ihren Spam- oder Junk-Ordner.',
  'authAction.loading': 'Ihr Link wird überprüft…',
  'authAction.error.missingInfo': 'Diesem Bestätigungslink fehlen erforderliche Informationen.',
  'authAction.error.unsupportedMode': 'Dieser Aktionstyp wird auf dieser Seite noch nicht unterstützt.',
  'authAction.error.expired': 'Dieser Link ist abgelaufen. Bitte fordern Sie einen neuen an.',
  'authAction.error.invalid': 'Dieser Link ist ungültig oder wurde bereits verwendet.',
  'authAction.error.userDisabled': 'Dieses Konto ist deaktiviert.',
  'authAction.error.userNotFound': 'Für diesen Link wurde kein Konto gefunden.',
  'authAction.error.weakPassword': 'Ihr neues Passwort ist zu schwach. Bitte wählen Sie ein stärkeres.',
  'authAction.error.generic': 'Wir konnten diesen Link nicht verarbeiten. Bitte fordern Sie einen neuen an und versuchen Sie es erneut.',
  'authAction.error.resetInvalid': 'Dieser Zurücksetzungslink ist ungültig. Bitte fordern Sie einen neuen an.',
  'authAction.error.passwordMin': 'Das Passwort muss mindestens 8 Zeichen lang sein.',
  'authAction.error.passwordMismatch': 'Die Passwörter stimmen nicht überein.',
  'authAction.verifySuccessTitle': 'E-Mail bestätigt',
  'authAction.verifySuccessBody': 'Ihre E-Mail ist jetzt verifiziert. Sie können sich anmelden, um fortzufahren.',
  'authAction.recoverSuccessTitle': 'E-Mail wiederhergestellt',
  'authAction.recoverSuccessBody': 'Ihre E-Mail-Änderung wurde erfolgreich rückgängig gemacht. Bitte melden Sie sich erneut an.',
  'authAction.continue': 'Weiter',
  'authAction.goToSignIn': 'Zur Anmeldung',
  'authAction.resetTitle': 'Neues Passwort festlegen',
  'authAction.resetBody': 'Passwort wird zurückgesetzt für {email}',
  'authAction.newPassword': 'Neues Passwort',
  'authAction.confirmNewPassword': 'Neues Passwort bestätigen',
  'authAction.updatePassword': 'Passwort aktualisieren',
  'authAction.resetSuccessTitle': 'Passwort aktualisiert',
  'authAction.resetSuccessBody': 'Ihr Passwort wurde erfolgreich zurückgesetzt.',
  'authAction.signIn': 'Anmelden',
  'authAction.linkUnavailableTitle': 'Link nicht verfügbar',
  'authAction.requestNewResetLink': 'Neuen Link zum Zurücksetzen anfordern',
  'authAction.backToSignIn': 'Zurück zur Anmeldung',
  'register.title': 'Konto erstellen',
  'register.fullName': 'Vollständiger Name',
  'register.operationDate': 'Transplantations-/Operationsdatum',
  'register.email': 'E-Mail',
  'register.password': 'Passwort',
  'register.confirmPassword': 'Passwort bestätigen',
  'register.createAccount': 'Konto erstellen',
  'register.haveAccount': 'Sie haben bereits ein Konto?',
  'register.signIn': 'Anmelden',
  'guide.comingSoon': 'Demnächst',
  'guide.motivation': 'Du schaffst das! Du kommst stärker zurück als je zuvor.',
  // Records page
  'records.todaysOverview': 'Heutige Übersicht',
  'records.selectedDayOverview': 'Übersicht des gewählten Tages',
  'records.weight': 'Gewicht',
  'records.fluids': 'Aufnahme',
  'records.fluidIntake': 'Flüssigkeitszufuhr',
  'records.foodIntake': 'Futteraufnahme',
  'records.urineOutput': 'Urinausscheidung',
  'records.saveWeight': 'Gewicht speichern',
  'records.undoWeight': 'Gewicht rückgängig',
  'records.weightRecorded': 'Gewicht erfasst',
  'records.weightRecordedToday': 'Gewicht heute erfasst',
  'records.add': 'Hinzufügen',
  'records.total': 'gesamt',
  'records.morningVitals': 'Morgenvitalwerte',
  'records.afternoonVitals': 'Nachmittagsvitalwerte',
  'records.morningVitalsRecorded': 'Morgenvitalwerte erfasst',
  'records.afternoonVitalsRecorded': 'Nachmittagsvitalwerte erfasst',
  'records.saveVitals': 'Vitalwerte speichern',
  'records.resetTodaysData': 'Heutige Daten zurücksetzen',
  'records.resetConfirmMessage': 'Alle heutigen Daten werden gelöscht. Dies kann nicht rückgängig gemacht werden.',
  'records.dailyLimitReached': 'Tageslimit erreicht (9999ml)',
  'records.newEntry': 'Neuer Eintrag',
  'records.addNewEntry': 'Neuen Eintrag hinzufügen',
  'records.saveEntry': 'Eintrag speichern',
  'records.cancel': 'Abbrechen',
  'records.date': 'Datum',
  'records.morning': 'Morgen',
  'records.afternoon': 'Nachmittag',
  'records.daily': 'Täglich',
  'records.bpSystolic': 'BD systolisch',
  'records.bpDiastolic': 'BD diastolisch',
  'records.pulse': 'Puls',
  'records.temp': 'Temp.',
  'records.downloadCsvFor': 'CSV herunterladen für:',
  'records.thisWeek': 'Diese Woche',
  'records.thisMonth': 'Diesen Monat',
  'records.thisYear': 'Dieses Jahr',
  'records.shareDataTitle': 'Daten mit Arzt teilen',
  'records.dataCopiedToClipboard': 'Daten in die Zwischenablage kopiert! Sie können sie jetzt in eine E-Mail oder Nachricht einfügen.',
  'records.noLogEntriesYet': 'Noch keine Einträge',
  'records.fillAtLeastOneField': 'Bitte füllen Sie mindestens ein Feld aus',
  'records.fluid': 'Flüssigkeit',
  'records.amBp': 'BD morgens',
  'records.amPulse': 'Puls morgens',
  'records.amTemp': 'Temp. morgens',
  'records.pmBp': 'BD nachmittags',
  'records.pmPulse': 'Puls nachmittags',
  'records.pmTemp': 'Temp. nachmittags',
  'records.vitals': 'Vitalwerte',
  'records.vitalsTime': 'Vitalwerte:',
  'records.filterBy': 'Filtern nach',
  'records.week': 'Woche',
  'records.month': 'Monat',
  'records.year': 'Jahr',
  'records.entry': 'Eintrag',
  'records.entries': 'Einträge',
  'records.today': 'Heute',
  'records.fluidIn': 'Flüssigkeit ein',
  'records.deleteLogEntry': 'Diesen Eintrag löschen?',
  'records.undoWeightEntry': 'Gewichtseintrag rückgängig',
  'records.undoLastFluidEntry': 'Letzten Flüssigkeitseintrag rückgängig',
  'records.undoLastUrineEntry': 'Letzten Urineintrag rückgängig',
  'records.toolbar.addNote': '+ Notiz hinzufügen',
  'records.toolbar.editNote': 'Notiz bearbeiten',
  'records.toolbar.intake': 'Aufnahme',
  'records.toolbar.saveNote': 'Notiz speichern',
  'records.toolbar.updateNote': 'Notiz aktualisieren',
  'records.toolbar.notesPlaceholder': 'Was notieren — Husten oder Niesen, Stress durch Ereignisse.\noder\nVeränderungen bei — Ausfluss, Schlaf, Appetit, Wasseraufnahme.',
  'records.toolbar.add': 'Hinzufügen',
  'records.toolbar.save': 'Speichern',
  'records.undoMorningVitals': 'Morgenvitalwerte rückgängig',
  'records.undoAfternoonVitals': 'Nachmittagsvitalwerte rückgängig',
  'records.amount': 'Menge',
  'records.tab.documents': 'Tresor',
  'records.documentsTitle': 'Dokumenten-Tresor',
  'records.documentsSubtitle': 'Bewahren Sie Ihre Laborwerte, Scans und Arztbriefe sicher an einem Ort auf.',
  'records.searchDocuments': 'Dokumente suchen…',
  'records.uploadDocument': 'Datei hochladen',
  'records.takePhoto': 'Foto aufnehmen',
  'records.maxFilesReached': 'Dateilimit für dieses Konto erreicht.',
  'records.categoryAll': 'Alle',
  'records.bucketLabs': 'Labor',
  'records.bucketScans': 'Scans',
  'records.bucketLetters': 'Arztbriefe',
  'records.bucketDischarge': 'Entlassungsunterlagen',
  'records.bucketPrescriptions': 'Rezepte',
  'records.bucketOther': 'Sonstiges',
  'records.noDocumentsYet': 'Noch keine Dokumente',
  'records.titleOptional': 'Titel (optional)',
  'records.noteOptional': 'Notiz (optional)',
  'records.documentDate': 'Dokumentdatum',
  'records.uploading': 'Wird hochgeladen…',
  'records.openFile': 'Öffnen',
  'records.deleteFile': 'Löschen',
  'records.deleteFileConfirm': 'Diese Datei aus dem Tresor löschen?',
  'records.dateAlreadyHasEntry': 'Dieses Datum hat bereits einen Eintrag. Verwenden Sie die Bearbeiten-Schaltfläche in der Tabelle.',
  'records.deleteEntry': 'Eintrag löschen',
  'records.deleteEntryConfirm': 'Möchten Sie alle Daten für dieses Datum wirklich löschen?',
  'records.editEntry': 'Eintrag bearbeiten',
  'records.observations': 'Beobachtungen',
  'records.howAreYouFeeling': 'Wie fühlen Sie sich heute?',
  'records.observationsPlaceholder': 'Was notieren — Husten oder Niesen, Stress durch Ereignisse.\noder\nVeränderungen bei — Ausfluss, Schlaf, Appetit, Wasseraufnahme.',
  'records.saveObservations': 'Beobachtungen speichern',
  'records.observationsRecorded': 'Beobachtungen gespeichert',
  'records.undoObservations': 'Beobachtungen zurücksetzen',
  'records.moodTerribleLabel': 'Sehr schlecht',
  'records.moodBadLabel': 'Nicht so gut',
  'records.moodOkayLabel': 'Okay',
  'records.moodGoodLabel': 'Gut',
  'records.moodGreatLabel': 'Sehr gut',
  'records.noObservations': 'Keine Beobachtungen',
  'records.mood': 'Stimmung',
  // Notification Center
  'notifications.title': 'Alle Erinnerungen',
  'notifications.allReminders': 'Alle Erinnerungen',
  'notifications.storageNote': 'Die letzten 5 Tage an Erinnerungen werden angezeigt.',
  'notifications.new': 'neu',
  'notifications.markAllRead': 'Alle als gelesen markieren',
  'notifications.allCaughtUp': 'Alles erledigt!',
  'notifications.clearAll': 'Alle löschen',
  'notifications.clearAllConfirm': 'Erneut tippen, um alles zu löschen',
  // Delete Confirm Modal
  'deleteConfirm.defaultTitle': 'Dieses Element löschen?',
  'deleteConfirm.cancel': 'Abbrechen',
  'deleteConfirm.delete': 'Löschen',
  'deleteConfirm.dontShowAgain': 'Nicht mehr anzeigen',
  // Settings Panel
  'settings.title': 'Einstellungen',
  'settings.preferences': 'Präferenzen',
  'settings.language': 'Sprache',
  'settings.units': 'Einheiten',
  'settings.metric': 'Metrisch',
  'settings.imperial': 'Imperial',
  'settings.dateFormat': 'Datumsformat',
  'settings.timeFormat': 'Zeitformat',
  'settings.logOut': 'Abmelden',
  'settings.editProfile': 'Profil bearbeiten',
  'settings.fullName': 'Vollständiger Name',
  'settings.profession': 'Beruf',
  'settings.professionPlaceholder': 'z.B. Krankenpfleger, Chirurg',
  'settings.emailAddress': 'E-Mail-Adresse',
  'settings.emailCannotChange': 'E-Mail kann nicht geändert werden.',
  'settings.transplantDate': 'Transplantationsdatum',
  'settings.changePassword': 'Passwort ändern',
  'settings.deleteAccount': 'Konto löschen',
  'settings.deleteAccountConfirm': 'Möchten Sie Ihr Konto wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.',
  'deleteAccount.title': 'Konto löschen?',
  'deleteAccount.bullet1': 'Sie werden sofort abgemeldet und können sich nicht mehr anmelden.',
  'deleteAccount.bullet2': 'Ihre Gesundheitsdaten, Medikamente und alle persönlichen Daten werden innerhalb von 30 Tagen dauerhaft gelöscht.',
  'deleteAccount.bullet3': 'Aktive Abonnements werden nicht automatisch gekündigt – bitte kündigen Sie diese separat in den Einstellungen.',
  'deleteAccount.footer': 'Diese Aktion kann nicht rückgängig gemacht werden.',
  'deleteAccount.confirm': 'Ja, mein Konto löschen',
  'deleteAccount.cancel': 'Konto behalten',
  'settings.cancel': 'Abbrechen',
  'settings.saveChanges': 'Änderungen speichern',
  // Meds page
  'meds.removeMedication': 'Medikament entfernen',
  'meds.removeConfirm': 'Möchten Sie dieses Medikament wirklich entfernen?',
  'meds.medCount': 'Med.',
  'meds.medsCount': 'Med.',
  'meds.remindersEnabled': 'Erinnerungen aktiviert',
  'meds.remindersDisabled': 'Erinnerungen deaktiviert',
  'meds.addMedication': 'Medikament hinzufügen',
  'meds.cancel': 'Abbrechen',
  'meds.medicationName': 'Medikamentenname',
  'meds.medicationNamePlaceholder': 'z.B. Tacrolimus',
  'meds.dosage': 'Dosierung',
  'meds.dosagePlaceholder': 'z.B. 1',
  'meds.timeslots': 'Uhrzeiten',
  'meds.addTime': '+ Zeit hinzufügen',
  'meds.type': 'Typ',
  'meds.shapeCapsule': 'Kapsel',
  'meds.shapeOval': 'Oval',
  'meds.shapeTwoPart': 'Zweiteilig',
  'meds.shapeDiamond': 'Raute',
  'meds.shapeRound': 'Rund',
  'meds.shapeFlat': 'Flach',
  'meds.shapeTriangle': 'Dreieck',
  'meds.pillColour': 'Pillenfarbe',
  'meds.customColour': 'Eigene Farbe',
  'meds.fillAllFields': 'Bitte füllen Sie alle Felder aus, einschließlich mindestens einer Uhrzeit',
  'meds.edit': 'Bearbeiten',
  'meds.delete': 'Löschen',
  'meds.duplicate': 'Duplizieren',
  'meds.dropHere': 'Hier ablegen zum Verschieben',
  'meds.editMedication': 'Medikament bearbeiten',
  'meds.saveChanges': 'Speichern',
  'contacts.edit': 'Bearbeiten',
  'contacts.delete': 'Löschen',
  'contacts.editContact': 'Kontakt bearbeiten',
  'contacts.addContact': 'Kontakt hinzufügen',
  'contacts.cancel': 'Abbrechen',
  'contacts.saveChanges': 'Speichern',
  'contacts.saveContact': 'Kontakt speichern',
  'contacts.name': 'Name',
  'contacts.phoneNumber': 'Telefonnummer',
  'contacts.email': 'E-Mail',
  'contacts.nephrologist': 'Nephrologe',
  'contacts.pharmacy': 'Apotheke',
  'contacts.emergency': 'Notfall',
  'contacts.other': 'Andere',
  'contacts.nameRequired': 'Name ist erforderlich',
  'contacts.phoneRequired': 'Telefonnummer ist erforderlich',
  'contacts.deleteContact': 'Kontakt löschen',
  'contacts.deleteContactMsg': 'Diesen Kontakt wirklich aus Ihrem Team entfernen?',
  'contacts.addNewContact': 'Neuen Kontakt hinzufügen',
  'contacts.noContacts': 'Noch keine Kontakte',
  'contacts.addCareTeam': 'Tippen Sie oben, um Ihr Team hinzuzufügen',
  'contacts.sortRecent': 'Neueste',
  'contacts.sortAlpha': 'Alphabetisch',
  'records.shareCard': 'Karte teilen',
  'records.undoObservation': 'Beobachtung rückgängig',
  // Notification settings
  'options.notifications': 'Benachrichtigungen',
  'options.notificationsAll': 'Alle',
  'options.notificationsLogs': 'Protokolle',
  'options.notificationsMeds': 'Medikamente',
  'options.notificationsNone': 'Keine',
  'options.subscription': 'Abonnement',
  'options.subscriptionSubtitle': 'Abrechnungszeitplan und Verlängerungsdetails.',
  'options.subscriptionPlan': 'Tarif',
  'options.subscriptionStatus': 'Status',
  'options.subscriptionStarted': 'Begonnen',
  'options.subscriptionNextPayment': 'Nächste Zahlung',
  'options.subscriptionExpires': 'Läuft ab',
  'options.subscriptionNoActive': 'Kein aktives Abonnement',
  'options.subscriptionUnavailable': 'Nicht verfügbar',
  'account.title': 'Kontoeinstellungen',
  'account.subtitle': 'Überprüfen Sie Ihr Profil und verwalten Sie Ihre Abonnementoptionen.',
  'account.profile': 'Profil',
  'account.profileSubtitle': 'Name, Tier-Details & Medizinkarte',
  'account.profileSaved': 'Profil gespeichert.',
  'account.profileSaveError': 'Profil konnte nicht gespeichert werden. Bitte erneut versuchen.',
  'account.savingProfile': 'Speichern…',
  'account.saveProfile': 'Profil speichern',
  'account.openDashboard': 'Dashboard öffnen',
  'account.starterTrial': 'Starter (Testphase)',
  'account.expired': 'Abgelaufen',
  'account.loading': 'Laden…',
  'account.trialDaysLeft': 'Testphase — noch {days} Tag{s}',
  'account.expiredDaysLeft': 'Abgelaufen — {days} Tag{s} zum erneuten Abonnieren',
  'account.currentPlan': 'Aktueller Tarif',
  'account.fetchingBilling': 'Aktuelle Abrechnungsdetails werden geladen.',
  'account.manageSubscription': 'Abonnement verwalten',
  'account.security': 'Konto & Sicherheit',
  'account.memberSince': 'Mitglied seit',
  'account.lastLogin': 'Letzte Anmeldung',
  'account.passwordResetSent': 'E-Mail zum Zurücksetzen wurde gesendet — bitte Posteingang prüfen.',
  'account.resetPassword': 'Passwort zurücksetzen',
  'account.resetPasswordEmailError': 'E-Mail zum Zurücksetzen konnte nicht gesendet werden. Bitte erneut versuchen.',
  'account.deleteRequiresRecentLogin': 'Aus Sicherheitsgründen bitte abmelden und erneut anmelden, bevor Sie Ihr Konto löschen.',
  'account.deleteFailed': 'Konto konnte nicht gelöscht werden. Bitte erneut versuchen.',
  'account.deleting': 'Löschen…',
  'account.dataPrivacy': 'Daten & Datenschutz',
  'account.exportDescription': 'Sie können alle mit Ihrem Konto verknüpften Daten als CSV exportieren.',
  'account.preparingExport': 'Export wird vorbereitet…',
  'account.downloadAllData': 'Alle meine Daten herunterladen',
  'options.notificationSettings': 'Erinnerungen',
  'options.remindersSubtitle': 'Medikamentenerinnerungen & Push-Benachrichtigungen',
  'options.permissions': 'Berechtigungen:',
  'options.activate': 'Aktivieren:',
  'options.logReminderTimes': 'Erinnerungszeiten für Protokolle:',
  'options.logReminderTime': 'Erinnerungszeit:',
  'options.permissionGrant': 'Berechtigung erteilen',
  'options.browserBlockedHelp': 'Benachrichtigungen werden von Ihrem Browser blockiert. Um sie zu aktivieren, klicken Sie auf das Schloss-/Info-Symbol in der Adressleiste und erlauben Sie Benachrichtigungen für diese Website.',
  'options.appOn': 'App: Ein',
  'options.appOff': 'App: Aus',
  'options.browserAllowed': 'Browser: Erlaubt',
  'options.browserUnsupported': 'Browser: Nicht unterstützt',
  'options.browserBlocked': 'Browser: Blockiert',
  'options.browserNotAsked': 'Browser: Nicht gefragt',
  'options.activityTitle': 'Aktivität',
  // Lab Glossary
  'guide.labGlossary.intro': 'Verstehen Sie gängige Laborwerte bei der Nachsorge nach der Transplantation. Diese Informationen sind zu Bildungszwecken — besprechen Sie Ihre Ergebnisse immer mit Ihrem Transplantationsteam.',
  'guide.labGlossary.search': 'Marker durchsuchen…',
  'guide.labGlossary.all': 'Alle',
  'guide.labGlossary.noMarkersFound': 'Keine Marker gefunden.',
  'guide.labGlossary.referenceRange': 'Typischer Referenzbereich',
  'guide.labGlossary.note': '⚠️ Hinweis',
  'guide.labGlossary.marker.creatinine.name': 'Creatinine',
  'guide.labGlossary.marker.creatinine.abbr': 'CREA',
  'guide.labGlossary.marker.creatinine.category': 'Kidney & Urinary',
  'guide.labGlossary.marker.creatinine.why': 'A core kidney marker in dogs and cats. Higher values can suggest reduced kidney filtration, but can also rise with dehydration.',
  'guide.labGlossary.marker.creatinine.typical': 'Dog: ~0.5–1.8 mg/dL · Cat: ~0.8–2.4 mg/dL (lab dependent).',
  'guide.labGlossary.marker.creatinine.note': 'Always interpret with SDMA, BUN, urine concentration, and hydration status.',
  'guide.labGlossary.marker.egfr.name': 'SDMA',
  'guide.labGlossary.marker.egfr.abbr': 'SDMA',
  'guide.labGlossary.marker.egfr.category': 'Kidney & Urinary',
  'guide.labGlossary.marker.egfr.why': 'Symmetric dimethylarginine can rise earlier than creatinine and helps detect early kidney changes.',
  'guide.labGlossary.marker.egfr.typical': 'Usually <14 µg/dL in many pet labs.',
  'guide.labGlossary.marker.egfr.note': 'Persistent increases are more meaningful than a one-off value.',
  'guide.labGlossary.marker.bun.name': 'Blood Urea Nitrogen',
  'guide.labGlossary.marker.bun.abbr': 'BUN / Urea',
  'guide.labGlossary.marker.bun.category': 'Kidney & Urinary',
  'guide.labGlossary.marker.bun.why': 'BUN reflects protein waste handling. It can rise with kidney disease, dehydration, GI bleeding, or high-protein diets.',
  'guide.labGlossary.marker.bun.typical': 'Dog: ~7–27 mg/dL · Cat: ~16–36 mg/dL (lab dependent).',
  'guide.labGlossary.marker.tacrolimus.name': 'ALP (Alkaline Phosphatase)',
  'guide.labGlossary.marker.tacrolimus.abbr': 'ALP',
  'guide.labGlossary.marker.tacrolimus.category': 'Liver',
  'guide.labGlossary.marker.tacrolimus.why': 'ALP can increase with liver or bile duct disease, steroid exposure, and growth in young pets.',
  'guide.labGlossary.marker.tacrolimus.typical': 'Often ~20–150 U/L in adult dogs/cats (method dependent).',
  'guide.labGlossary.marker.tacrolimus.note': 'Mild isolated rises can be non-specific; trend and context matter.',
  'guide.labGlossary.marker.ciclosporin.name': 'GGT (Gamma-Glutamyl Transferase)',
  'guide.labGlossary.marker.ciclosporin.abbr': 'GGT',
  'guide.labGlossary.marker.ciclosporin.category': 'Liver',
  'guide.labGlossary.marker.ciclosporin.why': 'GGT helps assess bile flow and hepatobiliary disease, often interpreted alongside ALP and bilirubin.',
  'guide.labGlossary.marker.ciclosporin.typical': 'Often low in healthy pets; reference limits vary by lab.',
  'guide.labGlossary.marker.mmf.name': 'Total Protein',
  'guide.labGlossary.marker.mmf.abbr': 'TP',
  'guide.labGlossary.marker.mmf.category': 'Proteins & Other',
  'guide.labGlossary.marker.mmf.why': 'Total protein combines albumin and globulins and can reflect hydration, inflammation, or protein loss.',
  'guide.labGlossary.marker.mmf.typical': 'Dog: ~5.5–7.5 g/dL · Cat: ~6.0–8.0 g/dL.',
  'guide.labGlossary.marker.potassium.name': 'Potassium',
  'guide.labGlossary.marker.potassium.abbr': 'K+',
  'guide.labGlossary.marker.potassium.category': 'Electrolytes',
  'guide.labGlossary.marker.potassium.why': 'Potassium affects heart and muscle function. Abnormal values may occur with kidney/urinary disease, vomiting, diarrhea, or urinary blockage.',
  'guide.labGlossary.marker.potassium.typical': 'Dog/Cat commonly ~3.5–5.5 mmol/L.',
  'guide.labGlossary.marker.potassium.note': 'Urgent abnormalities can occur with blocked cats and severe dehydration.',
  'guide.labGlossary.marker.sodium.name': 'Sodium',
  'guide.labGlossary.marker.sodium.abbr': 'Na+',
  'guide.labGlossary.marker.sodium.category': 'Electrolytes',
  'guide.labGlossary.marker.sodium.why': 'Sodium reflects fluid balance and can shift with dehydration, endocrine disease, and kidney/urinary issues.',
  'guide.labGlossary.marker.sodium.typical': 'Dog/Cat commonly ~140–160 mmol/L.',
  'guide.labGlossary.marker.bicarbonate.name': 'Chloride',
  'guide.labGlossary.marker.bicarbonate.abbr': 'Cl−',
  'guide.labGlossary.marker.bicarbonate.category': 'Electrolytes',
  'guide.labGlossary.marker.bicarbonate.why': 'Chloride helps acid-base and hydration assessment, especially with sodium and bicarbonate.',
  'guide.labGlossary.marker.bicarbonate.typical': 'Dog/Cat commonly ~105–122 mmol/L.',
  'guide.labGlossary.marker.phosphate.name': 'Phosphorus',
  'guide.labGlossary.marker.phosphate.abbr': 'PHOS',
  'guide.labGlossary.marker.phosphate.category': 'Kidney & Urinary',
  'guide.labGlossary.marker.phosphate.why': 'Phosphorus often rises as kidney disease progresses and is important for CKD staging and nutrition planning.',
  'guide.labGlossary.marker.phosphate.typical': 'Dog: ~2.5–6.0 mg/dL · Cat: ~2.5–6.8 mg/dL.',
  'guide.labGlossary.marker.calcium.name': 'Calcium',
  'guide.labGlossary.marker.calcium.abbr': 'Ca',
  'guide.labGlossary.marker.calcium.category': 'Electrolytes',
  'guide.labGlossary.marker.calcium.why': 'Calcium is important for nerves, muscle, and bones. Values may change with kidney disease, cancer, endocrine disorders, or low albumin.',
  'guide.labGlossary.marker.calcium.typical': 'Total calcium often ~8.5–11.8 mg/dL (species/lab dependent).',
  'guide.labGlossary.marker.haemoglobin.name': 'Red Cell Status',
  'guide.labGlossary.marker.haemoglobin.abbr': 'HGB / HCT / RBC',
  'guide.labGlossary.marker.haemoglobin.category': 'CBC',
  'guide.labGlossary.marker.haemoglobin.why': 'Red cell measurements assess anemia or dehydration. Chronic kidney disease can reduce red blood cell production.',
  'guide.labGlossary.marker.haemoglobin.typical': 'Ranges vary by species and analyzer; use your report\'s HGB/HCT/RBC intervals.',
  'guide.labGlossary.marker.wbc.name': 'White Blood Cell Count',
  'guide.labGlossary.marker.wbc.abbr': 'WBC',
  'guide.labGlossary.marker.wbc.category': 'CBC',
  'guide.labGlossary.marker.wbc.why': 'WBC helps assess inflammation, infection, stress response, and some bone marrow disorders.',
  'guide.labGlossary.marker.wbc.typical': 'Dog roughly ~6–17 ×10⁹/L · Cat ~5–19 ×10⁹/L.',
  'guide.labGlossary.marker.wbc.note': 'Look at differential counts (neutrophils/lymphocytes/eosinophils) for full interpretation.',
  'guide.labGlossary.marker.platelets.name': 'Platelets',
  'guide.labGlossary.marker.platelets.abbr': 'PLT',
  'guide.labGlossary.marker.platelets.category': 'CBC',
  'guide.labGlossary.marker.platelets.why': 'Platelets support blood clotting. Low platelets may increase bleeding risk; false lows can occur from platelet clumping.',
  'guide.labGlossary.marker.platelets.typical': 'Commonly ~200–500 ×10⁹/L (method dependent).',
  'guide.labGlossary.marker.altAst.name': 'ALT / AST',
  'guide.labGlossary.marker.altAst.abbr': 'ALT / AST',
  'guide.labGlossary.marker.altAst.category': 'Liver',
  'guide.labGlossary.marker.altAst.why': 'ALT/AST are liver-associated enzymes. Increases can reflect liver cell injury, inflammation, toxins, or muscle injury (especially AST).',
  'guide.labGlossary.marker.altAst.typical': 'Lab-specific; ALT is usually the more liver-specific value in dogs and cats.',
  'guide.labGlossary.marker.uricAcid.name': 'Albumin',
  'guide.labGlossary.marker.uricAcid.abbr': 'ALB',
  'guide.labGlossary.marker.uricAcid.category': 'Proteins & Other',
  'guide.labGlossary.marker.uricAcid.why': 'Albumin is a key blood protein that can drop with chronic inflammation, protein-losing kidney/gut disease, or liver dysfunction.',
  'guide.labGlossary.marker.uricAcid.typical': 'Dog: ~2.6–4.0 g/dL · Cat: ~2.5–3.9 g/dL.',
  'guide.labGlossary.marker.hba1c.name': 'Glucose',
  'guide.labGlossary.marker.hba1c.abbr': 'GLU',
  'guide.labGlossary.marker.hba1c.category': 'Metabolic',
  'guide.labGlossary.marker.hba1c.why': 'Glucose helps screen for diabetes and stress hyperglycemia (common in cats).',
  'guide.labGlossary.marker.hba1c.typical': 'Dog: ~70–120 mg/dL · Cat: ~70–150 mg/dL.',
  'guide.labGlossary.marker.cmv.name': 'Globulin',
  'guide.labGlossary.marker.cmv.abbr': 'GLOB',
  'guide.labGlossary.marker.cmv.category': 'Proteins & Other',
  'guide.labGlossary.marker.cmv.why': 'Globulins can increase with inflammation/infection and decrease with some immune or protein-losing disorders.',
  'guide.labGlossary.marker.cmv.typical': 'Dog: ~2.0–3.8 g/dL · Cat: ~2.8–5.1 g/dL.',
  'guide.labGlossary.marker.cmv.note': 'Interpret with albumin and total protein (A:G ratio is often useful).',
  'guide.labGlossary.marker.bkv.name': 'Bilirubin',
  'guide.labGlossary.marker.bkv.abbr': 'TBIL',
  'guide.labGlossary.marker.bkv.category': 'Liver',
  'guide.labGlossary.marker.bkv.why': 'Bilirubin can rise with liver disease, bile duct obstruction, or increased red blood cell breakdown.',
  'guide.labGlossary.marker.bkv.typical': 'Usually low/near-zero in healthy pets (lab dependent).',
  'guide.labGlossary.marker.upcr.name': 'Urine Protein:Creatinine Ratio',
  'guide.labGlossary.marker.upcr.abbr': 'UPC / UPCR',
  'guide.labGlossary.marker.upcr.category': 'Kidney & Urinary',
  'guide.labGlossary.marker.upcr.why': 'UPC estimates how much protein is lost in urine and helps monitor kidney disease progression and response to treatment.',
  'guide.labGlossary.marker.upcr.typical': 'Dog/Cat: <0.2 non-proteinuric, 0.2–0.5 borderline, >0.5 proteinuric (context matters).',
  'guide.labGlossary.marker.c0d.name': 'Urine Specific Gravity',
  'guide.labGlossary.marker.c0d.abbr': 'USG',
  'guide.labGlossary.marker.c0d.category': 'Kidney & Urinary',
  'guide.labGlossary.marker.c0d.why': 'USG measures urine concentration and is essential for interpreting kidney values and hydration status.',
  'guide.labGlossary.marker.c0d.typical': 'Highly variable; persistently low USG with high kidney markers may indicate kidney dysfunction.',
  'guide.labGlossary.category.kidneyFunction': 'Kidney & Urinary',
  'guide.labGlossary.category.immunosuppressants': 'Chemistry',
  'guide.labGlossary.category.electrolytes': 'Electrolytes',
  'guide.labGlossary.category.bloodCount': 'CBC',
  'guide.labGlossary.category.liverFunction': 'Liver',
  'guide.labGlossary.category.metabolic': 'Metabolic',
  'guide.labGlossary.category.infections': 'Proteins & Other',
  // Register legal
  'register.byRegistering': 'Mit der Registrierung stimmen Sie unseren',
  'register.and': 'und',
  'register.termsOfService': 'Nutzungsbedingungen',
  'register.privacyPolicy': 'Datenschutzrichtlinie',
  // CSV headers
  'records.csv.date': 'Datum',
  'records.csv.weight': 'Gewicht',
  'records.csv.fluidIn': 'Flüssigkeitsaufnahme',
  'records.csv.urineOut': 'Urinausscheidung',
  'records.csv.amRegistered': 'Morgen Registriert',
  'records.csv.amBP': 'RR Morgen',
  'records.csv.amPulse': 'Puls Morgen',
  'records.csv.amTemp': 'Temp. Morgen',
  'records.csv.pmRegistered': 'Abend Registriert',
  'records.csv.pmBP': 'RR Abend',
  'records.csv.pmPulse': 'Puls Abend',
  'records.csv.pmTemp': 'Temp. Abend',
  'records.csv.observations': 'Bemerkungen',
  'records.csv.healthDiary': 'Gesundheitstagebuch',
  // Roomies settings
  'options.roomies.description': 'Verbinden Sie sich mit post-transplantierten Patienten in Ihrer Gruppe. Alle Aktivitäten sind anonym.',
  'options.roomies.nickname': 'Spitzname',
  'options.roomies.nicknameMax': '(max. 12 Zeichen)',
  'options.roomies.nicknamePlaceholder': 'z. B. Phoenix',
  'options.roomies.beanColour': 'BEAN-Farbe',
  'options.roomies.groupCode': 'Gruppencode',
  'options.roomies.groupCodePlaceholder': 'Gruppencode eingeben oder teilen',
  'options.roomies.groupCodeHint': 'Teilen Sie diesen Code mit Ihren Mitpatienten, damit sie Ihrer Gruppe beitreten können.',
  'options.roomies.enableRoomies': 'Roomies aktivieren',
  'options.roomies.enableRoomiesHint': 'Erlauben Sie, dass Ihre Aktivitäten im Gruppen-Feed erscheinen',
  'options.roomies.noChanges': 'Keine Änderungen zu speichern',
  'options.roomies.saveProfile': 'Roomie-Profil speichern',
  'options.roomies.saved': 'Roomie-Profil gespeichert!',
  // Companionship (The Koda Fellowship)
  'companions.title': 'Gemeinschaft',
  'companions.pageTitle': 'Die Koda-Gefährten',
  'companions.subtitle': 'Sieh, wie sich dein Tier mit anderen weltweit misst.',
  'companions.publicView': 'Öffentliche Ansicht',
  'companions.publicViewHint': 'Wenn aktiv, erscheint dein Tier in der weltweiten Bestenliste der Koda-Gefährten. Deaktiviere, um privat zu bleiben — du kannst andere weiterhin sehen.',
  'companions.publicViewOn': 'In der Bestenliste sichtbar',
  'companions.publicViewOff': 'Aus der Bestenliste ausgeblendet',
  'companions.leaderboardTitle': 'Bestenliste',
  'companions.leaderboardEmpty': 'Noch keine Companions — sei der/die Erste!',
  'companions.leaderboardHint': 'Nach Level und aktueller Serie sortiert. Tippe ein Emoji, um anzufeuern.',
  'companions.you': 'Du',
  'companions.rank': 'Rang',
  'companions.score': 'Punkte',
  'companions.levelShort': 'Lv {n}',
  'companions.streakShort': '{n} Tage Serie',
  'companions.hiddenNotice': 'Du bist aus der Bestenliste ausgeblendet. Aktiviere die Öffentliche Ansicht in den Einstellungen.',
  'companions.tabAll': 'Gesamt',
  'companions.tabWeek': 'Diese Woche',
  'companions.weekXPShort': '+{n} XP diese Woche',
  'companions.leaderboardEmptyWeek': 'Diese Woche noch keine XP — erfasse Vitalwerte und steig auf!',
  'companions.leaderboardHintWeek': 'Sortiert nach XP seit Montag. Wird wöchentlich zurückgesetzt.',
  'companions.story.title': 'Begleiter-Status',
  'companions.story.modalTitle': 'Deine Begleiter-Story',
  'companions.story.hint': 'Wähle einen Chip und schreibe eine kurze Notiz. Sie erscheint unter deiner Zeile in der Bestenliste.',
  'companions.story.placeholder': 'Was gibt’s Neues bei deinem Begleiter?',
  'companions.story.save': 'Story speichern',
  'companions.story.edit': 'Story bearbeiten',
  'companions.story.clear': 'Story löschen',
  'companions.story.expiresIn': 'Läuft in {n} T ab',
  'companions.story.recovered': 'Genesen',
  'companions.story.vaccinated': 'Frisch geimpft',
  'companions.story.grooming': 'Frische Pflege',
  'companions.story.vetVisit': 'Tierarztbesuch',
  'companions.story.newTreat': 'Neues Leckerli',
  'companions.story.birthday': 'Geburtstag!',
  'companions.story.feelingGreat': 'Topfit',
  'companions.story.restingUp': 'Erholt sich',
  'companions.story.newHome': 'Neues Zuhause',
  // Bean page
  'bean.back': 'Zurück',
  'bean.level': 'Level',
  'bean.yourBean': 'Ihr BEAN',
  'bean.dailyStreak': 'Tages-Streak',
  'bean.current': 'Aktuell',
  'bean.best': 'Bestleistung',
  'bean.totalXP': 'Gesamt-XP',
  'bean.streakZero': 'Logge deine Vitalwerte heute und starte deinen Streak!',
  'bean.last30Days': 'Letzte 30 Tage',
  'bean.roomies': 'Gemeinschaft',
  'bean.active': 'Aktiv',
  'bean.connectText': 'Verbinde dich mit Tierhaltern weltweit. Feuert euch gegenseitig in der Bestenliste an — anonym.',
  'bean.setupRoomies': 'Aktiviere die Öffentliche Ansicht in Einstellungen → Gemeinschaft, um auf der Bestenliste zu erscheinen.',
  'bean.roomiesSettings': 'Companion-Einstellungen',
  'bean.preview': 'Vorschau',
  'bean.noActivity': 'Noch keine Companions — sie erscheinen hier, sobald sie Einträge machen.',
  'bean.keepGoing': 'Weiter so!',
  'bean.justNow': 'gerade eben',
  'bean.minsAgo': 'vor {n}Min.',
  'bean.hoursAgo': 'vor {n}Std.',
  'bean.daysAgo': 'vor {n}T.',
  'bean.levelName.seedling': 'Sämling',
  'trial.endsToday': 'Ihre Testphase endet heute — jetzt upgraden, um Ihre Daten zu behalten.',
  'trial.endsIn': 'Testphase endet in {days} Tag{s} — upgraden, um den Zugriff zu behalten.',
  'trial.upgrade': 'Upgraden',
  'trial.dismiss': 'Schließen',
  'layout.offlineBanner': 'Sie sind offline — Änderungen werden synchronisiert, sobald Sie wieder verbunden sind',
  'layout.reconnectSyncing': 'Wieder online — {n} ausstehende Änderung(en) werden synchronisiert…',
  'layout.reconnectSynced': 'Alle Änderungen synchronisiert ✓',
  'splash.preparing': 'Wir bereiten alles für Sie vor...',
  'bean.levelName.sprouting': 'Keimling',
  'bean.levelName.budding': 'Knospend',
  'bean.levelName.rooted': 'Verwurzelt',
  'bean.levelName.thriving': 'Aufblühend',
  'bean.levelName.flourishing': 'Blühend',
  'bean.levelName.resilient': 'Resilient',
  'bean.levelName.champion': 'Champion',
  'bean.levelName.guardian': 'Hüter',
  'bean.levelName.legend': 'Legende',
  'bean.feed.dailyLog': 'hat heute seine Vitalwerte eingetragen',
  'bean.feed.dailyLogStreak': 'hat seine Vitalwerte eingetragen 🔥 {n}-Tage-Streak',
  'bean.feed.streakMilestone': 'hat einen {n}-Tage-Streak erreicht! 🎉',
  'bean.feed.guideArticle': 'hat einen Führungsartikel gelesen',
  'bean.feed.joinedGroup': 'ist der Gruppe beigetreten',
  'bean.feed.changedLook': 'hat sein BEAN-Aussehen aktualisiert 🎨',
  'bean.celebration.levelUpTitle': 'Level {level}! 🎉',
  'bean.celebration.streakTitle': '{streak}-Tage-Streak! 🔥',
  'bean.celebration.levelUpBody': 'Sie haben {name} erreicht. Weiter so!',
  'bean.celebration.streakBody': '{streak} Tage in Folge — unglaubliche Konstanz!',
  // Notifications
  'notifications.medReminder': 'Medikamentenerinnerung',
  'notifications.medReminderBody': 'Zeit für: {meds}',
  'notifications.dailyReminder': 'Erinnerung Tagesprotokoll',
  'notifications.dailyReminderBody': 'Sie haben heute noch keine Daten eingetragen. Das Erfassen Ihrer Vitalwerte hilft, Ihre Gesundheit zu überwachen.',
  'notifications.alarmTitle': '💊 Medikamentenerinnerung',
  'notifications.alarmBody': 'Zeit für {name} ({dosage})',
  // Guide / Library page
  'guide.articles': 'Artikel',
  'guide.subtitle': 'Ratgeber, Werkzeuge & Unterlagen Ihres Haustieres.',
  'guide.resources': 'Ressourcen',
  'guide.minRead': 'Min. Lesezeit',
  'guide.unlocksInDay': 'Verfügbar in {n} Tag',
  'guide.unlocksInDays': 'Verfügbar in {n} Tagen',
  'guide.category.contacts.title': 'Medizinische Kontakte',
  'guide.category.contacts.subtitle': 'Alles an einem sicheren Ort.',
  'guide.category.medical_card.title': 'Medizinische Karte',
  'guide.category.medical_card.subtitle': 'Ihr medizinischer Ausweis.',
  'guide.category.emergency.title': 'Notfall-Tierarztfinder',
  'guide.category.emergency.subtitle': 'Jetzt die nächstgelegene Notfallpraxis finden.',
  'guide.category.how_to.title': 'Anleitung: Vitalwerte prüfen',
  'guide.category.how_to.subtitle': 'Schritt-für-Schritt nach Tierart.',
  'guide.category.hygiene.title': 'Hygiene',
  'guide.category.hygiene.subtitle': 'Die neue Normalität: Ein moderner Leitfaden zur Hygiene nach der Transplantation',
  'guide.category.exercise.title': 'Bewegung',
  'guide.category.exercise.subtitle': 'Die Kraft der Bewegung: Ein Bewegungsleitfaden nach der Transplantation',
  'guide.category.wellbeing.title': 'Wohlbefinden',
  'guide.category.wellbeing.subtitle': 'Stimmung, Mindset und Gewohnheiten',
  'guide.category.food.title': 'Ernährung',
  'guide.category.food.subtitle': 'Gut essen nach Ihrer Transplantation',
  'guide.category.nutrition.title': 'Ernährung',
  'guide.category.nutrition.subtitle': 'Gut essen nach Ihrer Transplantation',
  'guide.category.sleep.title': 'Schlaf',
  'guide.category.sleep.subtitle': 'Erholung und Schlafenszeit-Routine',
  'guide.category.lab_glossary.title': 'Labor-Glossar',
  'guide.category.lab_glossary.subtitle': 'Ihre Werte verstehen',
  'guide.category.vault.title': 'Medizinische Dateien',
  'guide.category.vault.subtitle': 'Hochladen, speichern und abrufen.',
  'guide.category.reminders.title': 'Erinnerungen',
  'guide.category.reminders.subtitle': 'Medikamentenalarme.',
  'guide.category.co-carers.title': 'Co-Carers',
  'guide.category.co-carers.subtitle': 'Share care with someone else.',
  // Auth — Register
  'register.disclaimerPrefix': 'Ich verstehe, dass KodaCare ein Gesundheits-Tracking-Tool und kein Medizinprodukt ist, und stimme der',
  'register.passwordStrength': 'Stärke:',
  'register.rule.minLength': 'Mindestens 8 Zeichen',
  'register.rule.uppercase': 'Großbuchstabe (A–Z)',
  'register.rule.lowercase': 'Kleinbuchstabe (a–z)',
  'register.rule.number': 'Zahl (0–9)',
  'register.rule.special': 'Sonderzeichen (!@#$…)',
  'register.strength.veryWeak': 'Sehr schwach',
  'register.strength.weak': 'Schwach',
  'register.strength.fair': 'Mittelmäßig',
  'register.strength.strong': 'Stark',
  'register.strength.veryStrong': 'Sehr stark',
  'register.error.emailInUse': 'Ein Konto mit dieser E-Mail existiert bereits.',
  'register.error.invalidEmail': 'Bitte geben Sie eine gültige E-Mail-Adresse ein.',
  'register.error.weakPassword': 'Passwort zu schwach. Bitte wählen Sie ein stärkeres.',
  'register.error.network': 'Netzwerkfehler. Überprüfen Sie Ihre Verbindung und versuchen Sie es erneut.',
  'register.error.generic': 'Registrierung fehlgeschlagen. Bitte versuchen Sie es erneut.',
  'register.error.passwordRequirements': 'Bitte erfüllen Sie alle Passwortanforderungen.',
  'register.error.passwordsMustMatch': 'Passwörter stimmen nicht überein.',
  'register.error.googleFailed': 'Google-Anmeldung fehlgeschlagen. Bitte versuchen Sie es erneut.',
  // Auth — Login
  'login.error.incorrectCredentials': 'Falsche E-Mail oder falsches Passwort.',
  'login.error.notVerified': 'Ihre E-Mail-Adresse wurde noch nicht verifiziert. Bitte prüfen Sie Ihren Posteingang.',
  'login.error.tooManyRequests': 'Zu viele Versuche. Bitte versuchen Sie es später erneut.',
  'login.error.network': 'Netzwerkfehler. Überprüfen Sie Ihre Verbindung und versuchen Sie es erneut.',
  'login.error.generic': 'Anmeldung fehlgeschlagen. Bitte versuchen Sie es erneut.',
  'login.error.googleFailed': 'Google-Anmeldung fehlgeschlagen. Bitte versuchen Sie es erneut.',
  // Medical Card
  'medcard.title': 'Medizinischer Ausweis',
  'medcard.saveTitleAttr': 'Im Profil speichern',
  'medcard.saved': 'Gespeichert ✓',
  'medcard.saving': 'Speichern…',
  'medcard.save': 'Speichern',
  'medcard.shareAlt': 'Als Bild teilen',
  'medcard.shareFailed': 'Teilen fehlgeschlagen',
  'medcard.hint': 'Tippen Sie auf ein Feld zum Bearbeiten · Speichern zum Synchronisieren',
  'medcard.diary.title': 'Gesundheitstagebuch',
  'medcard.diary.placeholder': 'Schreiben Sie alles über heute: Beobachtungen, allgemeines Wohlbefinden, Anzeichen von guter und schlechter Gesundheit…',
  'medcard.diary.saved': 'Gespeichert',
  'medcard.diary.saving': 'Wird gespeichert…',
  'medcard.fullName': 'Name des Hoomans',
  'medcard.profession': 'Name des Tieres',
  'medcard.dob': 'Rasse',
  'medcard.transplantDate': 'Transplantationsdatum',
  'medcard.hospital': 'Krankenhaus',
  'medcard.processNo': 'Aktennummer',
  'medcard.surgeon': 'Nephrologe',
  'medcard.allergies': 'Allergien',
  'medcard.avgWeight': 'Ø Gewicht',
  'medcard.medications': 'Aktuelle Medikamente',
  'medcard.avgBP': 'Ø Blutdruck',
  'medcard.placeholder.name': 'Namen eingeben',
  'medcard.placeholder.profession': 'Zum Eingeben tippen',
  'medcard.placeholder.dob': 'z. B. Britisch Kurzhaar',
  'medcard.placeholder.hospital': 'Name des Krankenhauses',
  'medcard.placeholder.processNo': 'z. B. 123456',
  'medcard.placeholder.surgeon': 'Name des Vet',
  'medcard.placeholder.allergies': 'Keine bekannt',
  // Records — Today's Card
  'records.todaysCard': 'Heutige Karte',
  'records.todaysCardComplete': 'Heutige Karte vollständig!',
  'records.allThreeLogged': 'Alle drei Schritte protokolliert — super Arbeit heute.',
  'records.filesTooLarge': '{n} Datei(en) übersprungen, größer als {mb} MB.',
  'records.stepLocked': 'Gesperrt',
  // Trends
  'trends.showLast': 'Zuletzt anzeigen:',
  // Guide wrappers
  'guide.renderError': 'Fehler beim Rendern des Inhalts:',
  // AppointmentCalendar
  'appt.kind.checkup': 'Kontrolle',
  'appt.kind.lab': 'Labor',
  'appt.kind.medication': 'Medikation',
  'appt.kind.other': 'Andere',
  'appt.noAppointments': 'Keine Termine an diesem Tag',
  'appt.upcoming': 'Bevorstehend',
  'appt.today': 'Heute',
  'appt.addEvent': 'Termin hinzufügen',
  'appt.editEvent': 'Termin bearbeiten',
  'appt.titleLabel': 'Titel',
  'appt.titlePlaceholder': 'z. B. Impfauffrischung',
  'appt.dateLabel': 'Datum',
  'appt.timeLabel': 'Uhrzeit',
  'appt.kindLabel': 'Art',
  'appt.doctorLabel': 'Tierarzt',
  'appt.doctorPlaceholder': 'Optional',
  'appt.locationLabel': 'Ort',
  'appt.locationPlaceholder': 'Optional',
  'appt.save': 'Speichern',
  'appt.cancel': 'Abbrechen',
  'appt.delete': 'Löschen',
  'appt.deleteConfirm': 'Diesen Termin löschen?',
  // Records share
  'records.weekOf': 'Woche vom',
  'records.share.title': 'KodaCare Tageszusammenfassung',
  'records.share.weight': 'Gewicht:',
  'records.share.morning': 'Morgen:',
  'records.share.afternoon': 'Nachmittag:',
  'records.share.fluidInOut': 'Flüssigkeit ein: {fluidIn}  |  Urin aus: {fluidOut}',
  'records.share.note': 'Notiz:',
  'records.share.dataTitle': 'KodaCare Gesundheitsdaten',
  'records.share.dataText': 'Meine Gesundheitsdaten aus KodaCare - {date}',
  // Notifications accessibility
  'notifications.dismiss': 'Schließen',
  'notifications.bellLabel': 'Benachrichtigungen',
  'notifications.settingsLabel': 'Benachrichtigungseinstellungen',
  'notifications.fallbackTitle': 'KodaCare Erinnerung',
  'fab.voiceHint': 'Wenn Sie bereit sind, sagen Sie „Timer starten Koda"',
  'fab.voicePhrase': 'timer starten koda',
  'notifications.fallbackBody': 'Sie haben eine neue Erinnerung.',
  // Vitals redesign stubs
  'records.heartRate': 'Heart Rate',
  'records.respRate': 'Respiratory Rate',
  'records.heartRateRecorded': 'Heart Rate Recorded',
  'records.respRateRecorded': 'Respiratory Rate Recorded',
  'records.temperatureRecorded': 'Temperature Recorded',
  'records.undoHeartRate': 'Undo heart rate',
  'records.undoRespRate': 'Undo respiratory rate',
  'records.undoTemperature': 'Undo temperature',
  'records.wellnessCheck': 'Wellness',
  'records.mucousMembranes': 'Mucous Membranes',
  'records.mm.pink': 'Pink',
  'records.mm.red': 'Red',
  'records.mm.blue': 'Blue',
  'records.mm.white': 'White',
  'records.csv.heartRate': 'Heart Rate (bpm)',
  'records.csv.respRate': 'Resp. Rate (bpm)',
  'records.csv.mucousMembrane': 'Mucous Membrane',
  'records.csv.temp': 'Temp',
  'records.share.fluidIn': 'Fluid In',
  'records.countFor15s': 'Count beats for 15 seconds',
  'records.countBreathsFor15s': 'Count breaths for 15 seconds',
  'records.beats': 'beats',
  'records.breaths': 'breaths',
  'records.saveHeartRate': 'Save Heart Rate',
  'records.saveRespRate': 'Save Respiratory Rate',
  'records.temperature': 'Temperature',
  'records.saveTemperature': 'Save Temperature',
  // Onboarding walkthrough
  'walkthrough.polyName': 'Koda',
  'walkthrough.skip': 'Überspringen',
  'walkthrough.back': 'Zurück',
  'walkthrough.letsGo': "Los geht's",
  'walkthrough.next': 'Weiter',
  'walkthrough.finish': 'Fertig! 🎉',
  'walkthrough.step0.title': 'Hallo, ich bin Koda!',
  'walkthrough.step0.body': 'Schön, Sie kennenzulernen! Ich habe ein Willkommensgeschenk von +30 XP für Sie vorbereitet. Mehr dazu später… Ich zeige Ihnen alles.',
  'walkthrough.step1.title': 'Täglicher Check-in',
  'walkthrough.step1.body': 'Tragen Sie die Vitalwerte Ihres Tieres hier so oft wie möglich ein – jeden Tag ist perfekt.',
  'walkthrough.step2.title': 'Gesundheitstrends',
  'walkthrough.step2.body': 'Sehen Sie, wie sich die Gesundheit Ihres Tieres im Laufe der Zeit verändert.',
  'walkthrough.step3.title': 'Medikamente',
  'walkthrough.step3.body': 'Verfolgen Sie Medikamente, Zeitpläne und Dosen – verpassen Sie nie eine Dosis mit Erinnerungen direkt auf Ihr Gerät.',
  'walkthrough.step4.title': 'Ihre Pflegebibliothek',
  'walkthrough.step4.body': 'Alles an einem Ort — Ratgeber für XP, der Tierausweis, Pflegeteam-Kontakte, Tierarztakten und mehr. Tippen Sie auf eine Ressource, um zu beginnen.',
  'walkthrough.step5.title': 'Ihr Fortschritt',
  'walkthrough.step5.body': 'Verfolge deine Streaks und deinen XP-Fortschritt und lerne andere Tierhalter in den Begleittabellen kennen.',
  'options.replayWalkthrough': 'Einführung wiederholen',
  'members.title': 'Mitbetreuende',
  'members.membersTitle': 'Aktuelle Mitglieder',
  'members.inviteTitle': 'Mitbetreuende einladen',
  'members.inviteHint': 'Erstelle einen sicheren Einladungslink und teile ihn direkt per iMessage, WhatsApp oder einer anderen Messaging-App.',
  'members.createLink': 'Einladungslink erstellen',
  'members.copyLink': 'Link kopieren',
  'members.copied': 'Kopiert!',
  'members.linkCopied': 'Link kopiert — teile ihn mit deiner Mitbetreuungsperson.',
  'members.inviteError': 'Einladung konnte nicht erstellt werden. Bitte erneut versuchen.',
  'members.pendingTitle': 'Ausstehende Einladungen',
  'members.cancelInvite': 'Abbrechen',
  'members.owner': 'Eigentümer',
  'members.remove': 'Zugang entfernen',
  'members.confirmRemove': '{name} als Mitbetreuenden entfernen?',
  'members.joinedOn': 'Beigetreten',
  'members.sentOn': 'Gesendet',
  'members.loading': 'Wird geladen…',
  'members.noMembers': 'Noch keine Mitglieder.',
  'members.viewOnlyNotice': 'Du bist Mitbetreuender dieses Haustieres. Nur der Eigentümer kann den Zugang verwalten.',
  'members.coCarers': 'Mitbetreuende',
  'members.coCarersSubtitle': 'Pflege für dieses Tier mit jemandem teilen',
  'members.transferTitle': 'Eigentümerschaft übertragen',
  'members.transferHint': 'Übertrage die vollständige Eigentümerschaft von {petName}s Profil an einen anderen KodaCare-Nutzer. Der Empfänger muss ein aktives Abonnement haben. Nach der Übertragung bleibst du Mitbetreuender.',
  'members.transferWarning': 'Diese Aktion ist dauerhaft und kann nicht rückgängig gemacht werden. Du verlierst deine Eigentümerrechte für dieses Tier.',
  'members.transferEmail': 'E-Mail-Adresse des Empfängers',
  'members.transferSelectCarer': 'Vorhandenen Mitbetreuenden auswählen:',
  'members.transferAction': 'Übertragen',
  'members.transferConfirm': 'Eigentümerschaft von {petName} an {email} übertragen? Diese Aktion kann nicht rückgängig gemacht werden.',
  'members.transferSuccess': 'Eigentümerschaft übertragen. Du bist jetzt Mitbetreuender dieses Tieres.',
  'members.transferError': 'Eigentümerschaft konnte nicht übertragen werden. Bitte erneut versuchen.',
  'coCarer.removedNotice.title': 'Du wurdest entfernt',
  'coCarer.removedNotice.body': 'Der Besitzer hat dich als Mitbetreuer für {petName} entfernt. Profil und Daten dieses Tieres werden nicht mehr in deinem Konto angezeigt.',
  'coCarer.removedNotice.ok': 'OK',
  'doses.markAsGiven': 'Als gegeben markieren',
  'doses.givenBy': 'Gegeben von',
  'doses.at': 'um',
  'doses.alreadyGiven': 'Bereits gegeben',
};